var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-card",
    { attrs: { bordered: false } },
    [
      _c(
        "div",
        { staticClass: "table-page-search-wrapper" },
        [
          _c(
            "a-form",
            {
              attrs: { layout: "inline" },
              nativeOn: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.searchQuery($event)
                }
              }
            },
            [
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { md: 6, sm: 12 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label:
                              _vm.language["PlatForm.employee.columns.workNo"]
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language[
                                  "PlatForm.employee.pleaseSetWorkNo"
                                ],
                              allowClear: ""
                            },
                            model: {
                              value: _vm.queryParam.workNo,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "workNo", $$v)
                              },
                              expression: "queryParam.workNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { md: 6, sm: 8 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: _vm.language["column.gender"] } },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: {
                                placeholder:
                                  _vm.language["warning.genderRequired"],
                                allowClear: ""
                              },
                              model: {
                                value: _vm.queryParam.sex,
                                callback: function($$v) {
                                  _vm.$set(_vm.queryParam, "sex", $$v)
                                },
                                expression: "queryParam.sex"
                              }
                            },
                            [
                              _c("a-select-option", { attrs: { value: "1" } }, [
                                _vm._v(_vm._s(_vm.language["common.sex.man"]))
                              ]),
                              _c("a-select-option", { attrs: { value: "2" } }, [
                                _vm._v(_vm._s(_vm.language["common.sex.woman"]))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.toggleSearchStatus
                    ? [
                        _c(
                          "a-col",
                          { attrs: { md: 6, sm: 8 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  label: _vm.language["column.realName"]
                                }
                              },
                              [
                                _c("a-input", {
                                  attrs: {
                                    placeholder:
                                      _vm.language[
                                        "PlatForm.employee.pleaseEnterRealName"
                                      ],
                                    allowClear: ""
                                  },
                                  model: {
                                    value: _vm.queryParam.realname,
                                    callback: function($$v) {
                                      _vm.$set(_vm.queryParam, "realname", $$v)
                                    },
                                    expression: "queryParam.realname"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { md: 6, sm: 8 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  label: _vm.language["column.cellphoneNumber"]
                                }
                              },
                              [
                                _c("a-input", {
                                  attrs: {
                                    placeholder:
                                      _vm.language[
                                        "warning.phoneNumberIncorrect"
                                      ],
                                    allowClear: ""
                                  },
                                  model: {
                                    value: _vm.queryParam.phone,
                                    callback: function($$v) {
                                      _vm.$set(_vm.queryParam, "phone", $$v)
                                    },
                                    expression: "queryParam.phone"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { md: 6, sm: 8 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  label:
                                    _vm.language[
                                      "PlatForm.employee.columns.isResigned"
                                    ]
                                }
                              },
                              [
                                _c(
                                  "a-select",
                                  {
                                    attrs: {
                                      placeholder:
                                        _vm.language["column.pleaseChoose"],
                                      allowClear: ""
                                    },
                                    model: {
                                      value: _vm.queryParam.isResigned,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.queryParam,
                                          "isResigned",
                                          $$v
                                        )
                                      },
                                      expression: "queryParam.isResigned"
                                    }
                                  },
                                  [
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "0" } },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.language["common.no"])
                                        )
                                      ]
                                    ),
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "1" } },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.language["common.yes"])
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "a-col",
                          { attrs: { md: 6, sm: 8 } },
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  label:
                                    _vm.language[
                                      "PlatForm.employee.columns.isUser"
                                    ]
                                }
                              },
                              [
                                _c(
                                  "a-select",
                                  {
                                    attrs: {
                                      placeholder:
                                        _vm.language["column.pleaseChoose"],
                                      allowClear: ""
                                    },
                                    model: {
                                      value: _vm.queryParam.isUser,
                                      callback: function($$v) {
                                        _vm.$set(_vm.queryParam, "isUser", $$v)
                                      },
                                      expression: "queryParam.isUser"
                                    }
                                  },
                                  [
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "0" } },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.language["common.no"])
                                        )
                                      ]
                                    ),
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "1" } },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.language["common.yes"])
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    : _vm._e(),
                  _c("a-col", { attrs: { md: 6, sm: 8 } }, [
                    _c(
                      "span",
                      {
                        staticClass: "table-page-search-submitButtons",
                        staticStyle: { float: "left", overflow: "hidden" }
                      },
                      [
                        _c(
                          "a-button",
                          {
                            attrs: { type: "primary", icon: "search" },
                            on: { click: _vm.searchQuery }
                          },
                          [_vm._v(_vm._s(_vm.language["common.searchButton"]))]
                        ),
                        _c(
                          "a-button",
                          {
                            staticStyle: { "margin-left": "8px" },
                            attrs: { type: "primary", icon: "reload" },
                            on: { click: _vm.searchReset }
                          },
                          [_vm._v(_vm._s(_vm.language["common.resetButton"]))]
                        ),
                        _c(
                          "a",
                          {
                            staticStyle: { "margin-left": "8px" },
                            on: { click: _vm.handleToggleSearch }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.toggleSearchStatus
                                    ? _vm.language["common.foldButton"]
                                    : _vm.language["common.unfoldButton"]
                                ) +
                                "\n              "
                            ),
                            _c("a-icon", {
                              attrs: {
                                type: _vm.toggleSearchStatus ? "up" : "down"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-operator", staticStyle: { "border-top": "5px" } },
        [
          _c(
            "a-button",
            {
              attrs: { type: "primary", icon: "plus" },
              on: { click: _vm.handleAdd }
            },
            [_vm._v(_vm._s(_vm.language["common.insertButton"]))]
          ),
          _c("j-third-app-button", {
            attrs: {
              "biz-type": "user",
              "selected-row-keys": _vm.selectedRowKeys,
              syncToApp: "",
              syncToLocal: ""
            },
            on: { "sync-finally": _vm.onSyncFinally }
          }),
          _c(
            "a-button",
            {
              attrs: { type: "primary", icon: "hdd" },
              on: {
                click: function($event) {
                  _vm.recycleBinVisible = true
                }
              }
            },
            [_vm._v(_vm._s(_vm.language["common.recycleBin"]))]
          ),
          _vm.selectedRowKeys.length > 0
            ? _c(
                "a-dropdown",
                [
                  _c(
                    "a-menu",
                    {
                      attrs: { slot: "overlay" },
                      on: { click: _vm.handleMenuClick },
                      slot: "overlay"
                    },
                    [
                      _c(
                        "a-menu-item",
                        { key: "1" },
                        [
                          _c("a-icon", {
                            attrs: { type: "delete" },
                            on: { click: _vm.batchDel }
                          }),
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.language["common.delete"]) +
                              "\n        "
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-menu-item",
                        { key: "2" },
                        [
                          _c("a-icon", {
                            attrs: { type: "lock" },
                            on: {
                              click: function($event) {
                                return _vm.batchFrozen("2")
                              }
                            }
                          }),
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.language["downBoxValue.freeze"]) +
                              "\n        "
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-menu-item",
                        { key: "3" },
                        [
                          _c("a-icon", {
                            attrs: { type: "unlock" },
                            on: {
                              click: function($event) {
                                return _vm.batchFrozen("1")
                              }
                            }
                          }),
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.language["common.thawButton"]) +
                              "\n        "
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-menu-item",
                        { key: "4" },
                        [
                          _c("a-icon", { attrs: { type: "unlock" } }),
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.language["PlatForm.employee.toUser"]) +
                              "\n        "
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-button",
                    { staticStyle: { "margin-left": "8px" } },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.language["common.batchAction"]) +
                          "\n        "
                      ),
                      _c("a-icon", { attrs: { type: "down" } })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "div",
            {
              staticClass: "ant-alert ant-alert-info",
              staticStyle: { "margin-bottom": "16px" }
            },
            [
              _c("i", {
                staticClass: "anticon anticon-info-circle ant-alert-icon"
              }),
              _vm._v(_vm._s(_vm.language["common.choosed"]) + " "),
              _c("a", { staticStyle: { "font-weight": "600" } }, [
                _vm._v(_vm._s(_vm.selectedRowKeys.length))
              ]),
              _vm._v(_vm._s(_vm.language["common.item"]) + "  \n      "),
              _c(
                "a",
                {
                  staticStyle: { "margin-left": "24px" },
                  on: { click: _vm.onClearSelected }
                },
                [_vm._v(_vm._s(_vm.language["common.clear"]))]
              )
            ]
          ),
          _c("a-table", {
            ref: "table",
            attrs: {
              bordered: "",
              size: "middle",
              rowKey: "id",
              columns: _vm.columns,
              dataSource: _vm.dataSource,
              pagination: _vm.ipagination,
              loading: _vm.loading,
              rowSelection: {
                selectedRowKeys: _vm.selectedRowKeys,
                onChange: _vm.onSelectChange
              }
            },
            on: { change: _vm.handleTableChange },
            scopedSlots: _vm._u([
              {
                key: "avatarslot",
                fn: function(text, record, index) {
                  return [
                    _c(
                      "div",
                      { staticClass: "anty-img-wrap" },
                      [
                        _c("a-avatar", {
                          attrs: {
                            shape: "square",
                            src: _vm.getAvatarView(record.avatar),
                            icon: "user"
                          }
                        })
                      ],
                      1
                    )
                  ]
                }
              },
              {
                key: "isResigned",
                fn: function(text, record, index) {
                  return [
                    _c("div", { staticClass: "anty-img-wrap" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            text === "1"
                              ? _vm.language["common.yes"]
                              : _vm.language["common.no"]
                          ) +
                          "\n        "
                      )
                    ])
                  ]
                }
              },
              {
                key: "status",
                fn: function(text, record, index) {
                  return [
                    _c("div", { staticClass: "anty-img-wrap" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            text === 1
                              ? _vm.language["downBoxValue.normal"]
                              : _vm.language["downBoxValue.freeze"]
                          ) +
                          "\n        "
                      )
                    ])
                  ]
                }
              },
              {
                key: "action",
                fn: function(text, record) {
                  return _c(
                    "span",
                    {},
                    [
                      _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              return _vm.handleEdit(record)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.language["common.edit"]))]
                      ),
                      record.status == 1 && record.isUser === "0"
                        ? _c("a-divider", { attrs: { type: "vertical" } })
                        : _vm._e(),
                      record.status == 1 && record.isUser === "0"
                        ? _c(
                            "a",
                            {
                              attrs: { href: "javascript:;" },
                              on: {
                                click: function($event) {
                                  return _vm.toUser(record)
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.language["PlatForm.employee.toUser"])
                              )
                            ]
                          )
                        : _vm._e(),
                      _c("a-divider", { attrs: { type: "vertical" } }),
                      _c(
                        "a-dropdown",
                        [
                          _c(
                            "a",
                            { staticClass: "ant-dropdown-link" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.language["common.more"]) +
                                  " "
                              ),
                              _c("a-icon", { attrs: { type: "down" } })
                            ],
                            1
                          ),
                          _c(
                            "a-menu",
                            { attrs: { slot: "overlay" }, slot: "overlay" },
                            [
                              _c(
                                "a-menu-item",
                                [
                                  _c(
                                    "a-popconfirm",
                                    {
                                      attrs: {
                                        title:
                                          _vm.language[
                                            "common.deleteConfirmInfo"
                                          ]
                                      },
                                      on: {
                                        confirm: function() {
                                          return _vm.handleDelete(record.id)
                                        }
                                      }
                                    },
                                    [
                                      _c("a", [
                                        _vm._v(
                                          _vm._s(_vm.language["common.delete"])
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              ),
                              record.status == 1
                                ? _c(
                                    "a-menu-item",
                                    [
                                      _c(
                                        "a-popconfirm",
                                        {
                                          attrs: {
                                            title:
                                              _vm.language[
                                                "tip.messageSureToFreeze"
                                              ]
                                          },
                                          on: {
                                            confirm: function() {
                                              return _vm.handleFrozen(
                                                record.id,
                                                2,
                                                record.username
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("a", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.language[
                                                  "downBoxValue.freeze"
                                                ]
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              record.status == 2
                                ? _c(
                                    "a-menu-item",
                                    [
                                      _c(
                                        "a-popconfirm",
                                        {
                                          attrs: {
                                            title:
                                              _vm.language[
                                                "tip.messageSureToThaw"
                                              ]
                                          },
                                          on: {
                                            confirm: function() {
                                              return _vm.handleFrozen(
                                                record.id,
                                                1,
                                                record.username
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("a", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.language[
                                                  "common.thawButton"
                                                ]
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                }
              }
            ])
          })
        ],
        1
      ),
      _c("sys-bm-employee-modal", {
        ref: "modalForm",
        on: { ok: _vm.modalFormOk }
      }),
      _c("password-modal", {
        ref: "passwordmodal",
        on: { ok: _vm.passwordModalOk }
      }),
      _c("sys-user-agent-modal", { ref: "sysUserAgentModal" }),
      _c("employee-recycle-bin-modal", {
        attrs: { visible: _vm.recycleBinVisible },
        on: {
          "update:visible": function($event) {
            _vm.recycleBinVisible = $event
          },
          ok: _vm.modalFormOk
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }